import { GoogleAuthProvider, signInWithPopup, signOut, User } from "firebase/auth"
import { auth } from "../firebaseApp"

class FirebaseService {
	private readonly auth = auth

	public async signInWithGoogle(): Promise<User | null> {
		this.auth.languageCode = "si" // TODO: read from react18next

		const signInResult = await signInWithPopup(this.auth, new GoogleAuthProvider())
		return signInResult.user ?? null
	}

	public async logout(): Promise<void> {
		await signOut(this.auth)
	}
}
export default new FirebaseService()
